import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthService} from "./auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {
          if (!this.checkLastLoginDate()) {
            this.authService.logout();
          }
        },
        (error) => {
          if (error.status === 401) {
            // Redirect to /login
            this.authService.logout();
          }
          if (!this.checkLastLoginDate()) {
            this.authService.logout();
          }
        }
      )
    );
  }

  checkLastLoginDate(): boolean {
    const lastLoginDate = this.authService.getLastLoginDate();

    if (lastLoginDate) {
      const now = new Date();
      const diffInHours = (now.getTime() - lastLoginDate.getTime()) / (1000 * 60 * 60);
      return diffInHours <= 24;
    }
    return false;
  }
}
